import type { ReferenceFormData } from "../types";

export const REFERENCE_FORM_ID = "reference-form";

export function getReferenceFormFieldId(formId: string, fieldName: keyof ReferenceFormData) {
  return `${formId}:field:${fieldName}` as const;
}

export function getReferenceFormFieldErrorId(fieldId: string) {
  return `${fieldId}:error`;
}
